import { render, staticRenderFns } from "./frontOfertarContainer.vue?vue&type=template&id=36ea1e04&"
import script from "./frontOfertarContainer.vue?vue&type=script&lang=js&"
export * from "./frontOfertarContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports